export const assert: (value: unknown, message?: string) => asserts value = (value, message) => {
    if (!value) {
        throw new Error(message ?? 'Asserted falsy value')
    }
}

export const assertNever = (value: never, description: string, valueForMessage?: string): Error => {
    return new Error('Unexpected ' + description + ': ' + (valueForMessage || value))
}
